







import { Component, Vue, Prop } from "vue-property-decorator";
import ErrorHandler from "@/components/ErrorHandler/ErrorHandler.vue";

@Component({
  components: {
    ErrorHandler,
  },
})
export default class App extends Vue {
  mounted() {
    if(this.$route.query.lang) {
      this.$i18n.locale = this.$route.query.lang.toString();
    }
  }
}
